import * as React from 'react';

import * as styles from './QuickFilterPriceWrapper.css';

interface IQuickFilterPriceWrapperProps extends React.PropsWithChildren {
  resetButton?: React.ReactNode;
}

export const QuickFilterPriceWrapper = ({ children, resetButton }: IQuickFilterPriceWrapperProps) => {
  return (
    <div className={styles['container']}>
      {children}
      {resetButton && <div className={styles['reset']}>{resetButton}</div>}
    </div>
  );
};
